<div class="d-flex justify-content-between p-px-16">
  <div mat-dialog-title class="fs-20 fw-7" >Mettre à jour vos données</div>
  <svg-icon src="assets/icons/close-modal.svg" class="cursor-pointer" (click)="close()" ></svg-icon>
</div>
<mat-dialog-content class="mat-typography">
  <div>
    <app-custom-input label="Nom de votre établissement" [required]="true"
    [parentForm]="form" controlName="name"
    ></app-custom-input>

    <app-custom-input label="Email principal" [required]="true" type="email" [parentForm]="form"
                      controlName="mailpersonnecontact"
                      [errorMessage]="'Veuillez saisir une adresse email valide'"
                      innerClass="mt-px-16"></app-custom-input>

    <app-custom-input label="Numéro SIRET" [required]="true" type="number" [parentForm]="form"
                      controlName="numsiret"
                      [errorMessage]="'Numéro SIRET doit avoir 14 numéro'"
                      innerClass="mt-px-16"></app-custom-input>

    <app-custom-drop-down [label]="'Type de l\'établissement'" [parentForm]="form"
                          controlName="typeetablissement"
                          innerClass="mt-px-16"

                          [options]="etablissementType" [simpleDropDown]="true"
    >

    </app-custom-drop-down>

    <app-custom-input [label]="'Nombre de salariés approximatif'" [parentForm]="form"
                          controlName="nombresalaries" type="number"
                      innerClass="mt-px-16"
    >

    </app-custom-input>

    <app-custom-input [label]="'Nombre annuel de patients pris en charge'" [parentForm]="form"
                          controlName="nombreannuelpatients"
                          type="number"
                      innerClass="mt-px-16">
    </app-custom-input>
    <app-custom-input label="Numéro FINESS" [required]="false"
                      controlName="numfiness"
                      [errorMessage]="'Numéro FINESS doit avoir 9 numéro'"
                      [parentForm]="form"
                      innerClass="mt-px-16"
                      type="number"></app-custom-input>

    <app-custom-input label="Description"
                      [required]="false" [parentForm]="form" innerClass="mt-px-16"
                      controlName="description" type="textarea"></app-custom-input>
<!-- P6 (client clinique) : Mode de gestion masqué — code conservé, la valeur existante est conservée telle quelle
<div class="fs-13 fw-bolder text-neutral-dark">
  Choisir votre mode de gestion de la partie administrative de l’intérim
  (contrats, fiche de paie, déclaration URSSAF…)
</div>
    <app-custom-checkbox [label]="'Par Collary'"
                         [value]="'COLLARY'"
                         [checked]="form.get('platformManagedBy')?.value == 'COLLARY'"
                         (change)="checkBoxChange($event, 'COLLARY')"
    ></app-custom-checkbox>

    <app-custom-checkbox [label]="'Par votre établissement'"
                         [value]="'YOURSELVES'"
                         (change)="checkBoxChange($event, 'YOURSELVES')"
                         [checked]="form.get('platformManagedBy')?.value == 'YOURSELVES'"
    ></app-custom-checkbox>
-->

  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="p-px-16">
  <app-button [stroked]="true" text="Annuler" (handleClick)="cancelAction()" ></app-button>
  <app-button [stroked]="false" class="ms-2" text="Confirmer les changements" [disabled]="loading || form.invalid"
              (handleClick)="editEstablishment()"
  ></app-button>
<!--  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button>-->
</mat-dialog-actions>
